/**
 * Resolves the auth-aware CTA target for the 404 page (`NotFound.jsx`).
 *
 * Lives in its own module (mirrors the `trialDaysLeft` helper pattern in
 * SubscriptionBanner) so the navigation contract — dashboard for signed-in
 * users, login for everyone else — is unit-testable without rendering. The
 * node-only Vitest setup has no DOM and can't render TanStack `Link`, and
 * keeping the helper out of the component file preserves react-refresh
 * (component files should export only components).
 *
 * @param {boolean} isAuthenticated
 * @returns {{ to: string, label: string }}
 */
function resolveAction(isAuthenticated) {
  return isAuthenticated
    ? { to: '/app/dashboard', label: 'Go to dashboard' }
    : { to: '/auth/login', label: 'Go to login' };
}

export { resolveAction };
export default resolveAction;
